import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";


const ProcurementWiseMIS = () => {
  const [datelist, setDatelist] = useState([]);

  const FillDetail = () => {
    const Datelst = [
      { name: "Direct Farmer Invoice", reportUrl: "/directfarmerinvoicereport", icon: "fa-file-invoice" },
      { name: "Direct Farmer Payment", reportUrl: "/directfarmerpaymentreport", icon: "fa-money-bill-wave" },
      { name: "Procurement Receipt Detail", reportUrl: "/procurementrecieptreport", icon: "fa-receipt" },
      { name: "Farmer Purchase List", reportUrl: "/farmerpurchasereport", icon: "fa-list" },
      { name: "Farmer Purchase Detail", reportUrl: "/farmerpurchaseDetailreport", icon: "fa-clipboard-list" },
    ];
    setDatelist(Datelst);
  };

  useEffect(() => {
    FillDetail();
  }, []);

  const colors = ["#e91e63", "#00c853", "#ff9800", "#2196f3", "#9c27b0"];

  return (
    <div className="content-wrapper p-4">
      <h4 className="mb-4 text-primary">📦 Procurement Report Dashboard</h4>

      <div className="row">
        {datelist.map((item, index) => (
          <div className="col-md-4 mb-3" key={index}>
            <Link to={item.reportUrl} className="text-decoration-none">
              <div
                className="report-box d-flex align-items-center shadow-sm p-3 rounded"
                style={{
                  borderLeft: `10px solid ${colors[index % colors.length]}`,
                  backgroundColor: "#fff",
                }}
              >
                <div
                  className="icon-circle d-flex justify-content-center align-items-center mr-3"
                  style={{
                    backgroundColor: colors[index % colors.length],
                    color: "white",
                  }}
                >
                  <i className={`fas ${item.icon}`} />
                </div>
                <div className="report-name text-dark font-weight-bold">
                  {item.name}
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <style>{`
        .report-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-radius: 12px;
        }
        .report-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        }
        .icon-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          font-size: 18px;
          flex-shrink: 0;
        }
        .report-name {
          font-size: 15px;
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
};

export default ProcurementWiseMIS;
